import { Injectable } from '@angular/core';

import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateCalculationService {

  constructor() { }



  formatSeconds(seconds : number) {
    let mm = Math.floor(Math.abs(seconds) / 60);
    console.log(mm);
    let ss = Math.abs(seconds) - (mm * 60);
    if(seconds < 0) mm = -mm;
    return Math.floor(mm) + "min" + Math.floor(ss) + "s";
  }


  /***
   * Calcule la difference de temps entre deux dates sans les days off et les heures non ouvrés
   */
  getDifference(dateDebut: Date, dateFin: Date) : string {
    let totalMilliseconds : number = dateFin.getTime() - dateDebut.getTime();
    let timeToSubstract : number = this.calculHourToSubstact(dateDebut, dateFin);

    totalMilliseconds = totalMilliseconds - timeToSubstract;
    let sortie : string;

    if(totalMilliseconds > 0) {
      sortie = new Date(totalMilliseconds).toISOString().substr(11,5);
    }else {
      sortie = "00:00";
    }

    return sortie;
  }

  /***
   * Calcule le nombre de milliseconde à soustraire
   */
  calculHourToSubstact (dateDebut: Date, dateFin: Date) : number {
    let timeToSubstract : number = 0;

    for( let date : Date = dateDebut; date.getTime() <= dateFin.getTime(); date.setMinutes(date.getMinutes() + 1) ) { //=> on calcul par minute
      if( date.getHours() < 8 || date.getHours() >= 17 || date.getDay() === 0 || date.getDay() === 6) {
        timeToSubstract++;
      }
    }

    return timeToSubstract * 1000 * 60; //=> on retourne en milliseconde
  }

  /***
   * Calcule le délai de traitement des moderations avec prise en compte des day off et heures non ouvrés
  */
  calculDelay(dateArrivee: string, delay: number) : Date {
    let dateFin : Date = new Date(dateArrivee);
    delay = delay * 60;
    let i:number=0;

    while(i < delay) {
      dateFin.setMinutes(dateFin.getMinutes() + 1);
      if(dateFin.getHours() < 8 || dateFin.getHours() >= 17 || dateFin.getDay() === 0 || dateFin.getDay() === 6){
        delay++;
      }
      i++;
    }
    return dateFin;
  }


  /**
   * Formate une date en string DD/MM/YYYY et renvoie un object qui contient une date et une heure convertie
   * @param date
   */
  getFormatedDate(date : Date) {
    let dd: any = date.getDate();
    let mm : any = date.getMonth() + 1;
    let yyyy = date.getFullYear();
    let hh : any = date.getHours();
    let MM : any = date.getMinutes();
    let ss : any = date.getSeconds();

    if(dd < 10) dd = '0' + dd;
    if(mm < 10) mm = '0' + mm;
    if(hh < 10) hh = '0' + hh;
    if(MM < 10) MM = '0' + MM;
    if(ss < 10) ss = '0' + ss;

     let results =  {
      date : dd + '/' + mm + '/' + yyyy,
      heure : hh + ':' + MM + ':' + ss
    }
     return results;
  }


  getEngFormatedDate(date : Date) {
    let dd: any = date.getDate();
    let mm : any = date.getMonth() + 1;
    let yyyy = date.getFullYear();
    let hh : any = date.getHours();
    let MM : any = date.getMinutes();
    let ss : any = date.getSeconds();

    if(dd < 10) dd = '0' + dd;
    if(mm < 10) mm = '0' + mm;
    if(hh < 10) hh = '0' + hh;
    if(MM < 10) MM = '0' + MM;
    if(ss < 10) ss = '0' + ss;

     let results =  {
      date : yyyy + '-' + mm + '-' + dd,
      heure : hh + ':' + MM + ':' + ss
    }
     return results;
  }

  /**
   * check si l'intervalle entre les deux dates ne dépasse pas le nombre en paramètre
   * Renvoie true si dépasse
   */
  checkIfPlusNDays(debut:Date, fin:Date, limite:number)   {
    let dateDebut = moment(debut);
    let dateFin = moment(fin);
    let diff = Math.abs(dateFin.diff(dateDebut, 'days'));
    
    return ((diff > limite) ? true : false);
  }

  /**
   * renvoie la langue française pour les dates
   */
  getFrLocale() {
    return {
      firstDayOfWeek: 1,
      dayNames: [ "Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi" ],
      dayNamesShort: [ "dim","lun","mar","mer","jeu","ven","sam" ],
      dayNamesMin: [ "Dim","Lun","Mar","Mer","Jeu","Ven","Sam" ],
      monthNames: [ "Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre" ],
      monthNamesShort: [ "jan","fev","mar","avr","mai","jun","jul","aou","sep","oct","nov","dec" ],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    }
  }

  /**
   * Renvoi le mois en français
   * @param dateNonFromatee
   */
  getCurrentMois(dateNonFromatee:string) {
    let splitted = dateNonFromatee.split('-');

    switch(parseInt(splitted[0])) {
      case 1 : {
        return 'Janvier ' + splitted[1];
        break;
      }
      case 2 : {
        return 'Février ' + splitted[1];
        break;
      }
      case 3 : {
        return 'Mars ' + splitted[1];
        break;
      }
      case 4 : {
        return 'Avril ' + splitted[1];
        break;
      }
      case 5 : {
        return 'Mai ' + splitted[1];
        break;
      }
      case 6 : {
        return 'Juin ' + splitted[1];
        break;
      }
      case 7 : {
        return 'Juillet ' + splitted[1];
        break;
      }
      case 8 : {
        return 'Août ' + splitted[1];
        break;
      }
      case 9 : {
        return 'Septembre ' + splitted[1];
        break;
      }
      case 10 : {
        return 'Octobre ' + splitted[1];
        break;
      }
      case 11 : {
        return 'Novembre ' + splitted[1];
        break;
      }
      case 12 : {
        return 'Décembre ' + splitted[1];
        break;
      }
    }
  }

  /**
   * Renvoi le mois en français
   * @param dateNonFromatee
   */
  getCurrentMoisSimple (dateNonFromatee:string) {
    let splitted = dateNonFromatee.split('-');
    console.log("parseInt"+parseInt(splitted[1]));
    switch(parseInt(splitted[1])) {
      case 1 : {
        return 'Janvier';
        break;
      }
      case 2 : {
        return 'Février';
        break;
      }
      case 3 : {
        return 'Mars';
        break;
      }
      case 4 : {
        return 'Avril';
        break;
      }
      case 5 : {
        return 'Mai';
        break;
      }
      case 6 : {
        return 'Juin';
        break;
      }
      case 7 : {
        return 'Juillet';
        break;
      }
      case 8 : {
        return 'Août';
        break;
      }
      case 9 : {
        return 'Septembre';
        break;
      }
      case 10 : {
        return 'Octobre';
        break;
      }
      case 11 : {
        return 'Novembre';
        break;
      }
      case 12 : {
        return 'Décembre';
        break;
      }
    }
  }
}
